import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import * as Icons from '@ant-design/icons-vue';
import axios from 'axios';
import { notification } from 'ant-design-vue';
import './assets/js/enums';

axios.defaults.baseURL = process.env.VUE_APP_SERVER;

axios.interceptors.request.use(function (config) {
  const adminToken = localStorage.getItem('adminToken');
  if (adminToken) {
    config.headers = config.headers || {};
    config.headers.token = config.headers.token || adminToken;
  }
  console.log('请求参数：', config);
  return config;
}, error => {
  return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
  console.log('返回结果：', response);
  return response;
}, error => {
  console.log('返回错误：', error);
  if (error.response && error.response.status === 401) {
    localStorage.removeItem('adminToken');
    notification.error({description: '登录已失效，请重新登录'});
    router.push('/login');
  }
  return Promise.reject(error);
});

console.log('环境：', process.env.NODE_ENV);
console.log('服务端：', process.env.VUE_APP_SERVER);

const app = createApp(App);

const icons = Icons;
for (const i in icons) {
  app.component(i, icons[i]);
}

app.use(Antd).use(store).use(router).mount('#app');
